<template>
    <div v-if="damages && damages.length > 0" class="damages-wrapper" style="page-break-inside:avoid;">
        <div class="column xl50">
            <h2></h2>

            <figure class="damagesImg">
                <img src="/backend/img/damage-car.svg" alt="Damages"/>
                    <div id="damage-markers">
                        <span v-for="(damage, index) in damages" v-bind:key="damage.id" class="damage-marker" :style="`top: ${damage.y}%; left: ${damage.x}%; background: #0054a6`"><span>{{index + 1}}</span></span>
                    </div>
            </figure>
            <div class="clearer"></div>
        </div>
        <div class="clearer"></div>
    </div>
</template>

<style scoped>
.damages-wrapper {
    position: relative;
    width: 80%;
  }
  .damagesImg {
    position: relative;
    width: 80%;
    z-index: 2;
  }

#damage-markers {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  width: 100%;
  height: 100%;
  /*background-color: red;*/
}
#damage-markers .damage-marker {
    position: absolute;
    border-radius: 50%;
    width: 1.5em;
    height: 1.5em;
    margin: 0 auto;
}
#damage-markers .damage-marker span {
    display: block;
    margin: auto;
    color: white;
    font-weight: bold;
    text-align: center;
}

@media (min-width: 568px) {
  .damages-wrapper {
    position: relative;
    width: 60%;
  }
  .damagesImg {
    position: relative;
    width: 60%;
    z-index: 2;
  }
}
</style>

<script>

export default {
  name: "Damages",
  props: [
    'damages'
  ],
  mounted() {}
}
</script>
